/* eslint-disable array-bracket-newline */
import {
  NOTIF_SEND,
  NOTIF_DISMISS,
  NOTIF_CLEAR,
} from '../actions/notifications';
import { StorageKeys } from '../helpers/localStorage';

export type NotifKind = 'info' | 'error' | 'warning' | 'success' | 'learn';

export interface INotif {
  kind: NotifKind;
  dismissAfter: number;
  id: number;
  title?: string;
  message: string | number;
}

/**
 * Fetch default state from localStorage
 */
const getDefaultState = (): INotif[] => {
  try {
    const items = window.localStorage?.getItem(StorageKeys.notifications);
    if (items) {
      const storedNotifications = JSON.parse(items);
      if (Array.isArray(storedNotifications)) {
        return storedNotifications;
      }
    }
    return [];
  } catch (err) {
    console.error('Could not parse current');
    return [];
  }
};

const defaultState = getDefaultState();

const notifs = (state: INotif[] = defaultState, action: any): INotif[] => {
  switch (action.type) {
  case NOTIF_SEND:
    return [
      action.payload,
      ...state.filter(({ id }) => id !== action.payload.id),
    ];
  case NOTIF_DISMISS:
    return state.filter(({ id }) => id !== action.payload);
  case NOTIF_CLEAR:
    return [];
  default:
    return state;
  }
};

export default notifs;
